module.exports = __webpack_public_path__ + "img/do.8f88e3b6.svg";